import type { ApolloCache } from "@apollo/client";

import { LIST_FINANCE_PACKAGES_QUERY } from "~/api";
import type { FinancePackage } from "~/types/finance";

type ListFinancePackagesData = {
  listFinancePackages?: FinancePackage[];
};

export const upsertFinancePackageInListCache = (
  cache: ApolloCache<unknown>,
  pkg: FinancePackage,
) => {
  cache.updateQuery<ListFinancePackagesData>(
    { query: LIST_FINANCE_PACKAGES_QUERY },
    (existing) => {
      if (!existing?.listFinancePackages) return existing;
      const index = existing.listFinancePackages.findIndex(
        (entry) => entry._id === pkg._id,
      );
      if (index === -1) {
        return {
          listFinancePackages: [...existing.listFinancePackages, pkg],
        };
      }
      const next = [...existing.listFinancePackages];
      next[index] = pkg;
      return { listFinancePackages: next };
    },
  );
};

export const removeFinancePackageFromListCache = (
  cache: ApolloCache<unknown>,
  id: string,
) => {
  cache.updateQuery<ListFinancePackagesData>(
    { query: LIST_FINANCE_PACKAGES_QUERY },
    (existing) => {
      if (!existing?.listFinancePackages) return existing;
      return {
        listFinancePackages: existing.listFinancePackages.filter(
          (entry) => entry._id !== id,
        ),
      };
    },
  );
};
